import * as React from "react";
import KnowladgeManipulation from "../containers/KnowladgeManipulation";

export default (props) => <KnowladgeManipulation {...props} />;
